export default __webpack_public_path__ + "static/media/groceries.c4172c26.svg";